import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { UrlApi } from "../../../../services/apirest.js";
import { formatDate } from "../utils/formatters.js";

function RemitosAsociadosFactura({ idFactura }) {
  const [remitos, setRemitos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (idFactura === null || idFactura === undefined) {
      setRemitos([]);
      setLoading(false);
      setError(false);
      return;
    }

    let cancelado = false;

    setLoading(true);
    setError(false);

    fetch(`${UrlApi}/remitos/por-factura/${idFactura}`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (cancelado) return;
        setRemitos(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (cancelado) return;
        setRemitos([]);
        setError(true);
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });

    return () => {
      cancelado = true;
    };
  }, [idFactura]);

  if (loading) {
    return (
      <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mt: 1 }}>
        <CircularProgress size={18} />
        <Typography variant="body2" color="text.secondary">
          Buscando remitos asociados…
        </Typography>
      </Stack>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ mt: 1, borderRadius: 2 }}>
        No se pudieron obtener los remitos de esta factura. Reintentá más tarde.
      </Alert>
    );
  }

  if (!remitos.length) {
    return (
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
        <InfoOutlinedIcon fontSize="small" color="disabled" />
        <Typography variant="body2" color="text.secondary">
          Esta factura no tiene remitos asociados.
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack spacing={1.5} sx={{ mt: 1 }}>
      {remitos.map((remito, index) => (
        <Box
          key={`${remito.tipo_remito}-${remito.id_remito ?? remito.nro_remito}-${index}`}
          sx={{
            p: 2,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            bgcolor: "action.hover",
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            flexWrap="wrap"
            sx={{ mb: 1 }}
          >
            <LocalShippingIcon fontSize="small" color="primary" />

            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Remito N° {remito.nro_remito || "-"}
            </Typography>

            <Chip
              size="small"
              variant="outlined"
              label={remito.tipo_remito || "SIN TIPO"}
            />
          </Stack>

          <Typography variant="body2" color="text.secondary">
            Fecha:{" "}
            {remito.fecha_remito
              ? formatDate(remito.fecha_remito)
              : "No disponible"}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}

export default RemitosAsociadosFactura;
